// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { Account, AccountRiskStatus, AnnualReview, CashBalance, Command, CommandReport, Contract, ContractGroup, ContractMaturity, Currency, Exchange, ExecutionReport, Fill, FillFee, FillPair, MarginSnapshot, Order, OrderStrategy, OrderStrategyLink, OrderStrategyType, OrderVersion, Position, Product, Property, SpreadDefinition, User, UserAccountAutoLiq, UserPlugin, UserPromoCode, UserProperty, UserReadStatus } from '@innolab-trader/tradovate-types'

export interface MultiSuggest {
  text: string
  limit: number
  entityTypes: Array<string>
}

export interface SyncMessage {
  users: Array<User>
  accounts?: Array<Account>
  accountRiskStatuses?: Array<AccountRiskStatus>
  marginSnapshots?: Array<MarginSnapshot>
  userAccountAutoLiqs?: Array<UserAccountAutoLiq>
  cashBalances?: Array<CashBalance>
  currencies?: Array<Currency>
  positions?: Array<Position>
  fillPairs?: Array<FillPair>
  orders?: Array<Order>
  contracts?: Array<Contract>
  contractMaturities?: Array<ContractMaturity>
  products?: Array<Product>
  exchanges?: Array<Exchange>
  spreadDefinitions?: Array<SpreadDefinition>
  commands?: Array<Command>
  commandReports?: Array<CommandReport>
  executionReports?: Array<ExecutionReport>
  orderVersions?: Array<OrderVersion>
  fills?: Array<Fill>
  fillFees?: Array<FillFee>
  orderStrategies?: Array<OrderStrategy>
  orderStrategyLinks?: Array<OrderStrategyLink>
  userProperties?: Array<UserProperty>
  properties?: Array<Property>
  userPlugins?: Array<UserPlugin>
  annualReviews?: Array<AnnualReview>
  userReadStatuses?: Array<UserReadStatus>
  userPromoCodes?: Array<UserPromoCode>
  contractGroups: Array<ContractGroup>
  orderStrategyTypes?: Array<OrderStrategyType>
}

/**
 * Validate MultiSuggest request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateMultiSuggest(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateMultiSuggest(request: MultiSuggest): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.text === undefined || req.text === null) {
    errors.push({
      field: 'text',
      code: 'required',
      message: 'text is required'
    })
  }
  if (typeof req.text === 'string' && req.text.length > 64) {
    errors.push({
      field: 'text',
      code: 'too_long',
      message: 'text must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.text === 'string' && req.text.trim() === '') {
    errors.push({
      field: 'text',
      code: 'required',
      message: 'text cannot be empty'
    })
  }

  if (req.limit === undefined || req.limit === null) {
    errors.push({
      field: 'limit',
      code: 'required',
      message: 'limit is required'
    })
  }

  if (req.entityTypes === undefined || req.entityTypes === null) {
    errors.push({
      field: 'entityTypes',
      code: 'required',
      message: 'entityTypes is required'
    })
  }

  return errors
}

export const multiSuggest = postEndpoint<MultiSuggest, SyncMessage>('/contract/multiSuggest')
